import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  STChange,
  STColumn,
  STComponent,
  STData,
  STReq,
  STRequestOptions,
  STRes,
} from '@delon/abc';
import { _HttpClient, ModalHelperOptions } from '@delon/theme';
import { format } from 'date-fns';
import { MessageService } from 'icc-common-lib';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../shared/constant/interface';
import { isJsonString } from '../../../shared/utils/common';
import { getEndDate, getStartDate } from '../../../shared/utils/time';

@Component({
  selector: 'app-msgRecord-sendDetail-tiktok',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.less'],
})
export class SendDetailTiktokCommentComponent implements OnInit {
  constructor(
    private messageService: MessageService,
    private http: _HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-sendDetail-comment';

  /* 详情 */
  detailItem = {
    isMo: false,
    msgType: null,
    content: '',
    title: '',
  };

  hisSuffixOffset = '';
  q: any = {
    params: {
      sendResult: -1, // 发布结果
      packName: '',
      postResult: -1, // 提交结果
      packId: '',
      shardTime: null,
      start: format(getStartDate(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
      end: format(getEndDate(new Date(), 0), 'yyyy-MM-dd HH:mm:ss'),
      appTypeId: 71,
      phone: '',
    },
  };

  expandForm = false;
  queryParams = {
    id: '0',
    isDetail: false,
    sentCount: 0,
    validTickets: 0,
    successCount: 0,
    failCount: 0,
    unknownCount: 0,
    moCount: 0,
    shardTime: null,
  };

  url = URLS.tiktokSendDetail.url;
  mediaUrl: any;
  imagUrl: any;
  tiktokMediaUrl = URLS.attachment.url + '?module=25&attach=7' + '&path=';
  options: ModalHelperOptions = {
    /** 大小；例如：lg、600，默认：`lg` */
    size: 1500,
  };

  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    {
      title: '批次名称',
      // index: 'batchName',
      render: 'tpl-batchName',
      fixed: 'left',
      width: 250,
      className: 'text-center',
    },
    // {
    //   title: '姓名',
    //   // index: 'userName',
    //   render: 'tpl-userName',
    //   width: 112,
    //   className: 'text-center',
    // },

    // {
    //   title: '所属分组',
    //   index: 'userGroups',
    //   render: 'userGroupsStr',
    //   width: 132,
    //   className: 'text-center',
    // },
    // {
    //   title: '评论ID',
    //   // index: 'terminalId',
    //   render: 'tpl-terminalId',
    //   width: 232,
    //   className: 'text-center',
    // },
    {
      title: '评论昵称',
      // index: 'terminalId',
      render: 'tpl-userName',
      width: 120,
      className: 'text-center',
    },
    {
      title: '评论内容',
      index: 'replyMocontent',
      width: 120,
      className: 'text-center',
    },
    {
      title: '回复评论内容',
      width: 150,
      className: 'text-center',
      render: 'tpl-content',
      // format: (item, _col, index) => {
      //   try {
      //     console.log(item);
      //     let content = item.content;
      //     content = JSON.parse(content);
      //     let contentTemp = content[0].content;
      //     if (contentTemp != null) {
      //       return contentTemp + '';
      //     } else {
      //       return '';
      //     }
      //   } catch (err) {
      //     console.log(err);
      //   }
      //   return '';
      // },
    },
    {
      title: '核验结果',
      index: 'bizFormState',
      type: 'badge',
      badge: {
        true: { text: '核验成功', color: 'success' },
        false: { text: '核验失败', color: 'error' },
      },
      width: 110,
      className: 'text-center',
    },
    {
      title: '核验报告',
      index: 'bizFormStr',
      width: 172,
      className: 'text-center',
    },
    {
      title: '提交结果',
      index: 'ticketState',
      type: 'badge',
      badge: {
        1: { text: '等待提交', color: 'processing' },
        2: { text: '提交成功', color: 'success' },
        3: { text: '取消提交', color: 'default' },
        4: { text: '提交失败', color: 'error' },
      },
      width: 110,
      className: 'text-center',
    },
    {
      title: '提交失败原因',
      // index: 'submitOriginResultStr',
      render: 'tpl-submitOriginResultStr',
      width: 130,
      className: 'text-center',
    },
    {
      title: '发送结果',
      index: 'result',
      width: 100,
      className: 'text-center',
      type: 'badge',
      badge: {
        1: { text: '成功', color: 'success' },
        2: { text: '失败', color: 'error' },
        3: { text: '未知', color: 'default' },
      },
    },
    // {
    //   title: '状态报告',
    //   index: 'sendResult',
    //   width: 150,
    //   className: 'text-center',
    // },
    {
      title: '发送抖音号',
      // index: 'channelName',
      render: 'tpl-channelName',
      width: 152,
      className: 'text-center',
    },
    {
      title: '发送人',
      // index: 'account',
      render: 'tpl-account',
      width: 152,
      className: 'text-center',
    },
    {
      title: '接收时间',
      index: 'postTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '提交时间',
      index: 'submitTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '送达时间',
      index: 'doneTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
  ];

  res: STRes = {
    process: (data, rawData) => {
      if (rawData.extparams && rawData.extparams.hisSuffixOffset) {
        this.hisSuffixOffset = rawData.extparams.hisSuffixOffset;
      }
      return data;
    },
  };

  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: this.q,
    process: (requestOptions: STRequestOptions) => {
      requestOptions.body.params.hisSuffixOffset = this.hisSuffixOffset;
      return requestOptions;
    },
  };
  // hasData = false;
  // res: STRes = {
  // process: (data: STData[], rawData: any) => {
  //     if (data.length) {
  //       this.hasData = true;
  //     }
  //     return data;
  // }
  // };
  // 选中的数据
  selectedRows: STData[] = [];

  /*searchOptions*/
  searchOptions: any = {
    appTypeId: 71,
    batchName: '',
    userName: '',
    title: '',
    officialAccount: '',
    phone: '',
    contentTypes: {
      contentType: -1,
      list: [
        {
          label: '全部',
          value: -1,
        },
        {
          label: '文本',
          value: 1,
        },
        {
          label: '图片',
          value: 2,
        },
        {
          label: '视频消息',
          value: 3,
        },
        {
          label: '企业消息卡片',
          value: 4,
        },
      ],
    },
    postResults: {
      postResult: -1,
      list: [
        {
          label: '全部',
          value: -1,
        },
        {
          label: '提交成功',
          value: 1,
        },
        {
          label: '提交失败',
          value: 2,
        },
      ],
    },
    packName: '',

    dateRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
    sendResults: {
      sendResult: -1,
      list: [
        {
          label: '全部',
          value: -1,
        },
        {
          label: '发布成功',
          value: 1,
        },
        {
          label: '发布失败',
          value: 2,
        },
        {
          label: '未知',
          value: 3,
        },
      ],
    },
  };
  isOpenExport = false;
  isOpenContentDetail = false;
  // 当前查看详情的模板
  currentTemplate: any = [];
  // 等待导出的文件路径列表
  waitingExportFiles: any = [];
  // 存放时间，用于过期
  waitingExportFilesMap: {
    [key: string]: Date;
  } = {};
  downloadPath = URLS.attachment.url + '?module=26&attach=2&path=';
  // 过期时间 10分钟
  expiredTime = 10 * 60 * 60 * 1000;

  _handleClose() {
    this.isOpenContentDetail = false;
  }

  /* 发送策略 */
  stChange(e: STChange) {
    switch (e.type) {
      case 'checkbox':
        this.selectedRows = e.checkbox;
        break;
    }
  }

  ngOnInit() {
    this.detailItem = {
      isMo: false,
      msgType: this.messageService.getMsgTypeByName('tiktok', true),
      content: '',
      title: '',
    };
    // 获取参数， 使用 queryParams
    this.queryParams.id = this.route.snapshot.queryParams.id || '';
    this.queryParams.isDetail =
      this.route.snapshot.queryParams.isDetail || false;
    this.q.params.packId = this.queryParams.id;
    this.queryParams.shardTime =
      new Date(this.route.snapshot.queryParams.shardTime) || new Date();
    this.q.params.shardTime = this.queryParams.shardTime;
    let start = new Date(
      this.queryParams.shardTime.getTime() - 24 * 60 * 60 * 1000
    ); // 前一天
    let end = new Date(
      this.queryParams.shardTime.getTime() + 24 * 60 * 60 * 1000
    ); // 后一天
    if (this.queryParams.isDetail) {
      this.q.params.start = format(
        getStartDate(start, 0),
        'yyyy-MM-dd HH:mm:ss'
      );
      this.q.params.end = format(getEndDate(end, 0), 'yyyy-MM-dd HH:mm:ss');
      this.searchOptions.dateRange = [
        getStartDate(start, 0),
        getEndDate(end, 0),
      ];
      this.url = URLS.tiktokSendRecordDetail.url;
      this.columns = [
        { title: '姓名', index: 'userName', width: 100 },

        {
          title: '所属分组',
          index: 'userGroups',
          render: 'userGroupsStr',
          width: 100,
        },
        {
          title: '评论ID',
          index: 'terminalId',
          width: 80,
        },
        {
          title: '评论内容',
          width: 120,
          index: 'replyMocontent',
        },
        {
          title: '回复评论内容',
          width: 150,
          render: 'tpl-content',
          // format: (item, _col, index) => {
          //   try {
          //     console.log(item);
          //     let content = item.content;
          //     content = JSON.parse(content);
          //     let contentTemp = content[0].content;
          //     if (contentTemp != null) {
          //       return contentTemp + '';
          //     } else {
          //       return '';
          //     }
          //   } catch (err) {
          //     console.log(err);
          //   }
          //   return '';
          // },
        },
        {
          title: '核验结果',
          index: 'bizFormState',
          type: 'badge',
          badge: {
            true: { text: '核验成功', color: 'success' },
            false: { text: '核验失败', color: 'error' },
          },
          width: 110,
        },
        {
          title: '核验报告',
          index: 'bizFormStr',
          width: 172,
        },
        {
          title: '提交结果',
          index: 'ticketState',
          type: 'badge',
          badge: {
            1: { text: '等待提交', color: 'processing' },
            2: { text: '提交成功', color: 'success' },
            3: { text: '取消提交', color: 'default' },
            4: { text: '提交失败', color: 'error' },
          },
          width: 110,
        },
        { title: '提交失败原因', index: 'submitOriginResultStr', width: 150 },
        {
          title: '发送结果',
          width: 100,
          index: 'result',
          type: 'badge',
          badge: {
            1: { text: '成功', color: 'success' },
            2: { text: '失败', color: 'error' },
            3: { text: '未知', color: 'default' },
          },
        },
        // { title: '状态报告', index: 'sendResult', width: 100 },
        {
          title: '发送抖音号',
          index: 'channelName',
          width: 120,
        },
        {
          title: '发送人',
          index: 'account',
          width: 100,
        },
        {
          title: '接收时间',
          index: 'postTime',
          type: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 170,
        },
        {
          title: '提交时间',
          index: 'submitTime',
          type: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 170,
        },
        {
          title: '送达时间',
          index: 'doneTime',
          type: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 170,
        },
      ];
    }
    this.queryStatistical();
  }

  isJsonString(str) {
    try {
      if (typeof JSON.parse(str) === 'object') {
        return true;
      }
    } catch (e) {}
    return false;
  }

  queryStatistical() {
    // 查询统计数据
    if (this.queryParams.isDetail) {
      this.http
        .post(URLS.sendRecordDetail.url, {
          packId: this.q.params.packId,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
        })
        .subscribe((res) => {
          if (res.status === 0) {
            res.data.forEach((value) => {
              if (value.msgType === 7) {
                this.queryParams.sentCount = value.msgCount || 0;
                this.queryParams.validTickets = value.validTickets || 0;
                this.queryParams.successCount = value.successCount || 0;
                this.queryParams.failCount = value.failureCount || 0;
                this.queryParams.unknownCount = value.unknownNum || 0;
                this.queryParams.moCount = value.moCount || 0;
              }
            });
          }
        });
    }
  }

  multiLineDisplay(list, rows) {
    let resultStr = '';
    let br = '<br />';
    if (list && list instanceof Array) {
      for (let i = 0; i < list.length; i++) {
        if (rows <= 0) {
          resultStr += list[i].name + br;
        } else if (i < rows) {
          resultStr += list[i].name + br;
        } else {
          resultStr = resultStr.slice(0, resultStr.length - br.length) + '...';
          break;
        }
      }
      if (rows <= 0 || list.length <= rows) {
        resultStr = resultStr.slice(0, resultStr.length - br.length);
      }
    }
    return resultStr;
  }

  getTableList() {
    this.hisSuffixOffset = '';
    this.st.reset({
      params: {
        hisSuffixOffset: this.hisSuffixOffset,
        packId: this.q.params.packId,
        shardTime: this.q.params.shardTime,
        sendResult: this.searchOptions.sendResults.sendResult,
        contentType: this.searchOptions.contentTypes.contentType,
        batchName: this.searchOptions.batchName,
        account: this.searchOptions.userName,
        title: this.searchOptions.title,
        officialAccount: this.searchOptions.officialAccount,
        packName: this.searchOptions.packName,
        postResult: this.searchOptions.postResults.postResult,
        appTypeId: this.searchOptions.appTypeId,
        phone: this.searchOptions.phone,
        start:
          this.searchOptions.dateRange.length >= 1
            ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
            : null,
        end:
          this.searchOptions.dateRange.length >= 2
            ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
            : null,
      },
    });
    this.queryStatistical();
  }

  resetTableList() {
    // 重置搜索条件
    this.hisSuffixOffset = '';
    if (this.queryParams.isDetail) {
      this.searchOptions.sendResults.sendResult =
        this.searchOptions.sendResults.list[0].value;
    } else {
      this.searchOptions.sendResults.sendResult =
        this.searchOptions.sendResults.list[0].value;
    }
    // this.searchOptions.bizFormStates.bizFormState = -1;
    this.searchOptions.packName = '';
    this.searchOptions.phone = '';
    this.searchOptions.userName = '';
    this.searchOptions.postResults.postResult =
      this.searchOptions.postResults.list[0].value;
    if (this.queryParams.isDetail) {
      let start = new Date(
        this.queryParams.shardTime.getTime() - 24 * 60 * 60 * 1000
      ); // 前一天
      let end = new Date(
        this.queryParams.shardTime.getTime() + 24 * 60 * 60 * 1000
      ); // 后一天
      this.searchOptions.dateRange = [
        getStartDate(start, 0),
        getEndDate(end, 0),
      ];
    } else {
      this.searchOptions.dateRange = [
        getStartDate(new Date(), 7),
        getEndDate(new Date(), 0),
      ];
    } // 重新加载table数据
    this.getTableList();
  }

  goExport() {
    this.router.navigateByUrl('/system/import-export/export');
  }

  closeExport() {
    this.isOpenExport = false;
  }

  export() {
    // 判断前端表格是否有数据，如果没有，则直接返回“无数据可导出”
    if (!this.st._data || this.st._data.length === 0) {
      this.dialogService.notification.warning('导出', '无数据可导出');
      return;
    }
    this.http
      .post(URLS.tiktokSendDetailExport.url, {
        params: {
          hisSuffixOffset: '',
          packId: this.q.params.packId,
          shardTime: this.q.params.shardTime,
          sendResult: this.searchOptions.sendResults.sendResult,
          contentType: this.searchOptions.contentTypes.contentType,
          batchName: this.searchOptions.batchName,
          account: this.searchOptions.userName,
          title: this.searchOptions.title,
          officialAccount: this.searchOptions.officialAccount,
          packName: this.searchOptions.packName,
          phone: this.searchOptions.phone,
          postResult: this.searchOptions.postResults.postResult,
          appTypeId: this.searchOptions.appTypeId,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
        },
      })
      .subscribe((res) => {
        if (res.status === 0) {
          this.isOpenExport = true;
        } else {
          this.dialogService.notification.error('导出', res.errorMsg);
        }
      });
  }

  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkDate() {
    if (this.searchOptions.dateRange[0]) {
      // 设置开始时间为选择日期的 00:00:00
      this.searchOptions.dateRange[0] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[0]).toLocaleDateString()
        ).getTime()
      );
    }
    if (this.searchOptions.dateRange[1]) {
      // 设置开始时间为选择日期的 23:59:59
      this.searchOptions.dateRange[1] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[1]).toLocaleDateString()
        ).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
    }
  }

  getConmment(content) {
    if (content && isJsonString(content)) {
      return JSON.parse(content) && JSON.parse(content)[0]
        ? JSON.parse(content)[0].content
        : '';
    } else {
      return '';
    }
  }
}
